import React from 'react';
import clsx from 'clsx';
import { TestimonialsV5 } from 'types/studio/studio';
import { getThemeCSSClass } from 'shared/utils/getThemeCSSClass';
import { ChevronLeftIcon, ChevronRightIcon } from '@ag1/ui';
import { TestimonialsSliderArrowsProps } from './types';
import styles from './styles.module.scss';

const TestimonialsSliderArrows = ({
  onScrollPrev,
  onScrollNext,
  theme
}: TestimonialsSliderArrowsProps & Pick<TestimonialsV5, 'theme'>) => (
  <div className={styles.root}>
    <button
      type="button"
      className={clsx(styles.button, getThemeCSSClass(theme))}
      aria-label="Prev Slide Button"
      onClick={onScrollPrev ? () => onScrollPrev() : undefined}
      disabled={!onScrollPrev}>
      <ChevronLeftIcon titleAccess="Previous" />
    </button>
    <button
      type="button"
      className={clsx(styles.button, getThemeCSSClass(theme))}
      aria-label="Next Slide Button"
      onClick={onScrollNext ? () => onScrollNext() : undefined}
      disabled={!onScrollNext}>
      <ChevronRightIcon titleAccess="Next" />
    </button>
  </div>
);

export default TestimonialsSliderArrows;
